import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone\"><path d=\"M776.564 1024H247.436a107.644 107.644 0 0 1-107.458-107.613V107.675A107.644 107.644 0 0 1 247.436 0H776.44a107.706 107.706 0 0 1 107.551 107.613v808.65A107.613 107.613 0 0 1 776.564 1024z m48.842-916.325a48.935 48.935 0 0 0-48.81-48.904h-529.16a48.935 48.935 0 0 0-48.935 48.904v635.377h626.812V107.675z m0 693.962H198.594v114.812a48.935 48.935 0 0 0 48.81 48.904H776.41a48.966 48.966 0 0 0 48.563-42.76 49.648 49.648 0 0 0 0.372-6.206V801.575zM514.141 936.774a52.752 52.752 0 1 1 52.752-52.752 52.752 52.752 0 0 1-52.783 52.752z m-172-807.533h344.125a29.386 29.386 0 0 1 0 58.74H342.14a29.386 29.386 0 0 1-0.03-58.74z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone.svg
// module id = 7pRf
// module chunks = 65